import { Card, CardContent, Divider, Grid } from '@material-ui/core'
import React from 'react'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import FormProperties from './FormProperties'
import CustomAttributeUrls from "../../../apiUrls/sco-jm-custom-attr/CustomAttributeUrls"
import CustomAttributeValueCrudTable from './customattributevalue/Custom_Attr_Value_TablePage'
import TranslationText from './TranslationText'

const {
  form: { CngEditForm },
  card: { CngSimpleCardHeader }
} = components

function EditPage({ showNotification }) {
  const { id } = useParams()
  const translatedTextObject = TranslationText()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CngSimpleCardHeader title={translatedTextObject.customAttrHeader} />
          <Divider />
          <CardContent>
            <Grid item xs={12}>
              <CngEditForm
                fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
                showNotification={showNotification}
                bodySection={
                  <FormProperties.Fields
                    disabled={false}
                    showNotification={showNotification}
                  />
                }
                formikProps={FormProperties.formikProps}
                toClientDataFormat={FormProperties.toClientDataFormat}
                toServerDataFormat={FormProperties.toServerDataFormat}
                fetch={{
                  url: CustomAttributeUrls.CUSTOM_ATTR_GET
                }}
                update={{
                  url: CustomAttributeUrls.CUSTOM_ATTR_UPADTE
                }}
                id={id}
              />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <CustomAttributeValueCrudTable customAttributeId={id} isViewOnly={false} showNotification={showNotification} />
      </Grid>
    </Grid>

  )
}

export default EditPage
